/**
 * Engine API
 * Civilization Engine API
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Action
 */
export interface BattleFrontAction { 
    /**
     * Civilization name
     */
    civilizationName: string;
    /**
     * Front number, started with 1
     */
    frontNumber: number;
}